export const DishwasherIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="52"
    height="56"
    viewBox="0 0 52 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.600098 11.4023V48.7646C0.600098 49.9239 1.53839 50.8661 2.7016 50.8661H48.7647C49.924 50.8661 50.8662 49.9278 50.8662 48.7646V11.4023H0.603979H0.600098Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50.8623 3.60117V11.4024H0.600098V3.60117C0.600098 1.94554 1.94554 0.600098 3.60117 0.600098H47.8612C49.5169 0.600098 50.8623 1.94554 50.8623 3.60117Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.966 50.8623L47.3418 52.7893C46.9928 53.8672 45.9847 54.6001 44.8525 54.6001H6.61402C5.47795 54.6001 4.4737 53.8711 4.12474 52.7893L3.50049 50.8623H47.9738H47.966Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.0915 15.3728H9.37046C6.89713 15.3728 4.89209 17.3778 4.89209 19.8512V42.2778C4.89209 44.7511 6.89713 46.7562 9.37046 46.7562H42.0915C44.5648 46.7562 46.5698 44.7511 46.5698 42.2778V19.8512C46.5698 17.3778 44.5648 15.3728 42.0915 15.3728Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4626 4.88086H7.47489C6.59049 4.88086 5.87354 5.59781 5.87354 6.48221V6.48996C5.87354 7.37436 6.59049 8.09131 7.47489 8.09131H16.4626C17.347 8.09131 18.0639 7.37436 18.0639 6.48996V6.48221C18.0639 5.59781 17.347 4.88086 16.4626 4.88086Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.4213 8.40139C32.4792 8.40139 33.3367 7.54383 33.3367 6.48597C33.3367 5.42812 32.4792 4.57056 31.4213 4.57056C30.3634 4.57056 29.5059 5.42812 29.5059 6.48597C29.5059 7.54383 30.3634 8.40139 31.4213 8.40139Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.5477 8.40139C38.6056 8.40139 39.4632 7.54383 39.4632 6.48597C39.4632 5.42812 38.6056 4.57056 37.5477 4.57056C36.4899 4.57056 35.6323 5.42812 35.6323 6.48597C35.6323 7.54383 36.4899 8.40139 37.5477 8.40139Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.6737 8.40139C44.7316 8.40139 45.5891 7.54383 45.5891 6.48597C45.5891 5.42812 44.7316 4.57056 43.6737 4.57056C42.6159 4.57056 41.7583 5.42812 41.7583 6.48597C41.7583 7.54383 42.6159 8.40139 43.6737 8.40139Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.3658 35.1589V37.3884C39.3658 38.8618 38.1716 40.056 36.6982 40.056H14.194C12.7206 40.056 11.5264 38.8618 11.5264 37.3884V35.1589H39.3658Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.3606 35.159C23.7518 34.0074 23.4067 32.6968 23.4067 31.3049C23.4067 28.9474 24.3955 26.8188 25.9813 25.3105C26.5125 24.8064 27.1096 24.3721 27.761 24.0232C28.9242 23.395 30.2581 23.0383 31.6733 23.0383C36.2369 23.0383 39.9398 26.7373 39.9398 31.3049C39.9398 32.6968 39.5947 34.0113 38.986 35.159"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.6555 35.1588C36.6674 34.1429 37.2917 32.7393 37.2917 31.1922C37.2917 28.0865 34.7753 25.5701 31.6696 25.5701C31.0065 25.5701 30.3745 25.6864 29.7852 25.8958C29.2113 26.0974 28.684 26.3921 28.2148 26.7604C26.8965 27.7879 26.0513 29.3931 26.0513 31.1922C26.0513 32.7393 26.6755 34.139 27.6875 35.1588"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4233 35.1591C15.83 34.0191 15.4966 32.7241 15.4966 31.3515C15.4966 26.7878 19.1956 23.085 23.7631 23.085C25.1784 23.085 26.5122 23.4417 27.6754 24.0698"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5485 35.1591C18.5481 34.1509 17.9277 32.7667 17.9277 31.2352C17.9277 28.1604 20.4209 25.6711 23.4917 25.6711C24.147 25.6711 24.7596 25.7797 25.3412 25.9852"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
